import { FaceDto, SectionFragmentDto, SectionFragmentType} from "@hec/api-dtos";

export const GetSectionFragmentByTypeFromFace = (face: FaceDto, sft: SectionFragmentType): SectionFragmentDto | null => {
  const result = face?.sectionFragments.find(x=> x.sectionFragmentType === sft);
  return result ?? null;
}
